export interface Instalment {
  instalment_id: number;
  project_id: number;
  amount: number;
  invoice_no: number | null;
  invoice_date: string;
  due_date: string;
  status: "Paid" | "Unpaid" | "Due";
  invoice: string | null;
  address: string;
  job_number: string;
}

// to single object maping
export const mapInstalment = (data: any): Instalment => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const response: Instalment = {
    instalment_id: data.instalment_id,
    project_id: data.project_id,
    amount: data.amount,
    invoice_no: data.invoice_no ?? null,
    invoice_date: data.invoice_date,
    due_date: data.due_date,
    status: data.status,
    invoice: data.invoice ?? null,
    address: data.address,
    job_number: data.job_number,
  };

  return response;
};

// maping list objects
export const mapInstalments = (data: any[]): Instalment[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }
  return data.map(mapInstalment);
};

export interface Payment {
  instalments?: Instalment[];
  next_invoice_no?: string;
}

// to single object maping
export const mapPayment = (data: any): Payment => {
  if (!data) {
    throw new Error("Invalid Data");
  }
  const res: Payment = {
    instalments: mapInstalments(data.data),
    next_invoice_no: data.next_invoice_no,
  };
  return res;
};
